'use strict';

const _ = require('underscore');
const Backbone = require('backbone/backbone');
const gsap = require('gsap').default;
const Events = require('constants/Events');
const Constants = require('constants/Constants');
require('./TopNav.less');

const Selectors = {
    el: '.TopNav',
    logoImg: '.TopNav-logoImg',
    path: '.TopNav-logoImg path#b',
    letter: '.TopNav-logoLetter',
    item: '.TopNav-item',
    button: '.TopNav-buttonsSignIn,.TopNav-buttonsContactUs,.TopNav-hamburger'
};

const BindFunctions = [
    'onPageLoaded',
    'onIterationStart',
    'updateLettersStyles',
    '_attachEvents',
    'onScroll',
    'setDarkTheme',
    'setLightTheme'
];

const LoaderDuration = 0.8;
const LoaderRepeatDelay = 0.3;
const LetterBaseAnimationDuration = 0.167;
const SingleLetterAnimationDelay = 0.02;
const PurpleColor = '#1C0976';
const GreenColor = '#1CC283';
const ScrollTopOffset = 10;

module.exports = Backbone.View.extend({

    el: Selectors.el,

    initialize: function (options = {}) {
        _.bindAll(this, BindFunctions);
        window.gsap = gsap;
        this.options = options;
        this.isPageLoaded = false;
        this.$path = this.$(Selectors.path);
        this.$letters = this.$(Selectors.letter);
        this.$buttons = this.$(Selectors.button);
        this.$items = this.$(Selectors.item);
        this.isScrolled = false;
        // app.vent.on(Events.home.hero.sequenceEntered, this.onStartPlay);
        app.vent.on(Events.common.pageLoaded, this.onPageLoaded);
        setTimeout(() => {
            this.timeline = gsap.timeline({
                repeat: -1,
                repeatDelay: LoaderRepeatDelay,
                onRepeat: this.onIterationStart
            });
            gsap.set(this.$path[0], {strokeDasharray: '100 110'});
            this.timeline.fromTo(
                this.$path[0],
                {strokeDashoffset: '100'},
                {
                    strokeDashoffset: '-110',
                    duration: LoaderDuration,
                    ease: 'topNavLogo'
                }
            );
        }, 5);
    },

    _attachEvents: function () {
        app.vent.on(Events.common.scroll, this.onScroll);
    },

    onScroll: function (scrollTop) {
        const isTopNavOnBackground = scrollTop > ScrollTopOffset;
        if (isTopNavOnBackground === this.isScrolled) {
            return;
        }

        this.isScrolled = isTopNavOnBackground;
        this.$el.toggleClass(Constants.cssClasses.isScrolled, isTopNavOnBackground);
    },

    onPageLoaded: function () {
        this.isPageLoaded = true;
        this._attachEvents();
    },

    onIterationStart: function () {
        if (!this.isPageLoaded) {
            return;
        }

        this.timeline.clear();
        this.timeline.kill();

        gsap.set(this.$path[0], {strokeDasharray: 110});
        gsap.fromTo(this.$path[0],
            {strokeDashoffset: '110'},
            {
                strokeDashoffset: '0',
                duration: LoaderDuration / 2,
                ease: 'topNavLogo'
            });

        this.lettersTimeline = gsap.timeline({onComplete: this.updateLettersStyles});
        this.$letters.each((index, letter) => {
            const delay = (index + 1) * SingleLetterAnimationDelay;
            this.animateLetters(letter, delay);
        });
        this.$items.addClass(Constants.cssClasses.isShow);
        this.$buttons.addClass(Constants.cssClasses.isShow);
    },

    updateLettersStyles: function () {
        this.$letters
            .css({[`${Constants.cssProperties.opacity}`]: '', [`${Constants.cssProperties.fill}`]: ''})
            .addClass(Constants.cssClasses.isShow);
    },

    animateLetters: function (letter, delay) {
        gsap.set(letter, {
            opacity: 0,
            fill: GreenColor
        });

        this.lettersTimeline
            .to(letter, {
                opacity: 1,
                fill: GreenColor,
                duration: LetterBaseAnimationDuration,
                ease: 'expo.out'
            }, delay)
            .to(letter, {
                opacity: 1,
                fill: PurpleColor,
                duration: LetterBaseAnimationDuration,
                ease: 'expo.out'
            }, delay * 1.5 + LetterBaseAnimationDuration);
    },

    setDarkTheme: function () {
        window.app.state.isTopNavDark = true;
        this.$el.addClass(Constants.cssClasses.isDark);
    },

    setLightTheme: function () {
        window.app.state.isTopNavDark = false;
        this.$el.removeClass(Constants.cssClasses.isDark);
    }
});
